import { forwardRef } from 'react';

import { Box, AssistanceIcon, BoxProps } from '@frontend/components';

import { AssistanceAvailableBackground } from './AssistanceAvailableBackground';

export const AssistanceIconWithBackground = forwardRef<
  HTMLDivElement,
  BoxProps
>((props, ref) => {
  return (
    <Box position="relative" bottom={2} left={4} ref={ref} {...props}>
      <AssistanceAvailableBackground boxSize={4} top={0} right={0} />
      <AssistanceIcon
        boxSize="1.375rem"
        color="alert.assistance"
        top="0.3125rem"
        right="0.3125rem"
        position="absolute"
      />
    </Box>
  );
});
AssistanceIconWithBackground.displayName = 'AssistanceIconWithBackground';
